export function resolveLink({ configuredUrl, fallbackUrl }) {
  const trimmed =
    typeof configuredUrl === 'string' ? configuredUrl.trim() : '';
  if (trimmed) {
    return trimmed;
  }
  return fallbackUrl;
}
